<template>
    <div class="components-page__BLMSearchGroupItem">
        <p class="components-page__BLMSearchGroupItem__header" v-show="isShowHeader">
            <slot name="header">
                <h5>{{title}}</h5>
            </slot>
        </p>
        <section class="components-page__BLMSearchGroupItem__section">
            <slot></slot>
        </section>
    </div>
</template>

<script>
// import BLMH3Title from '../BLMH3Title/BLMH3Title.vue'
export default {
  name: 'BLMSearchGroupItem',
  //   components: {
  // BLMH3Title,
  //   },
  inject: ['blmSearchInstance'],
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    isShowHeader() {
      return this.blmSearchInstance.showAll
    },
  },
}
</script>

<style lang="less" scoped>
.components-page__BLMSearchGroupItem {
    &__header {
        h5 {
            margin-left: 0;
            font-size: 16px;
        }
    }
    &__section {
        display: flex;
        flex-wrap: wrap;
        * {
            display: inherit;
        }
    }
}
</style>
